/* Copyright (c) 2020-present CloudIO Inc */

import { Checkbox as MUICheckbox, CheckboxProps } from '@mui/material';
import React from 'react';

const Checkbox = (
  props: Omit<CheckboxProps, 'color'> & {
    'data-testid': string;
    'data-tip'?: string;
  },
): React.ReactElement => {
  return (
    <MUICheckbox
      color="primary"
      {...props}
      data-testid={`io-${props['data-testid']}`}
      inputProps={{
        ...props.inputProps,
        // @ts-ignore data-testid is a valid prop for input
        'data-testid': `io-${props['data-testid']}-input`,
        'data-tip': props['data-tip'],
      }}
    />
  );
};

export default Checkbox;
